import Heading from './heading'
import { HeadingSizes, HeadingWeights } from './heading'

export { HeadingSizes, HeadingWeights }

export default Heading
